import { render, staticRenderFns } from "./creditcustomer-content.vue?vue&type=template&id=f5c3b39c&scoped=true"
import script from "./creditcustomer-content.vue?vue&type=script&lang=ts"
export * from "./creditcustomer-content.vue?vue&type=script&lang=ts"
import style0 from "./creditcustomer-content.vue?vue&type=style&index=0&id=f5c3b39c&prod&lang=css"
import style1 from "./creditcustomer-content.vue?vue&type=style&index=1&id=f5c3b39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c3b39c",
  null
  
)

export default component.exports